// src/App.js
import React, { useState, useCallback, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';

import './App.css';


// LEX App import
import {
  HomePage as LexappHomePage,  // alias the dashboard
  AppsLoader                   // leave the loader under its own name
} from './Lexapp';

// your pages / components…
import Lexcode               from './Lexcode';
import GestureMouseControl   from './Lexcode/components/GestureMouseControl';
import TopMenuBar            from './components/TopMenuBar';
import HomePage              from './pages/HomePage';
import ForYou                from './pages/ForYou';
import OurCompany            from './pages/OurCompany';
import Partners              from './components/partners';

import SignUp                from './user/SignUp';
import Login                 from './user/Login';
import ForgotPassword        from './user/ForgotPassword';
import { AuthProvider }      from './user/AuthContext';
import PrivateRoute          from './user/PrivateRoute';
import UserDashboard         from './user/UserDashboard';
import ProfilePanel          from './user/ProfilePanel';
import SecurityPanel         from './user/SecurityPanel';
import BillingPanel          from './user/BillingPanel';
import HistoryPanel          from './user/HistoryPanel';
import AssistantPanel        from './user/AssistantPanel';

import { LexBuild }          from './Lexbuild/LexBuild';
import StudioPage            from './Lexbuild/Studio';

import LexAcquire            from './Lexacquire/LexAcquire';
import Landscape             from './Lexacquire/Landscape';
import Leaderboard           from './Lexacquire/Leaderboard';
import Featured              from './Lexacquire/Featured';
import Newest                from './Lexacquire/Newest';
import Trending              from './Lexacquire/Trending';
import MostViewed            from './Lexacquire/MostViewed';
import MostVoted             from './Lexacquire/MostVoted';
import Submit                from './Lexacquire/Submit';
import Request               from './Lexacquire/Request';
import Sponsorship           from './Lexacquire/Sponsorship';

import LexPromptApp          from './Lexprompt';
import LexNoteApp            from './Lexnote/LexNoteApp';
import LexMail from './Lexmail/LexMail';


import PromptListPage        from './Lexprompt/pages/PromptListPage';

import GenerativeSearch      from './LexGSEO/GenerativeSearch';

import AdminSignup           from './pages/Admin/AdminSignup';
import AdminLogin            from './pages/Admin/Login';
import ProfileSubmission     from './pages/Admin/ProfileSubmission';
import AdminDashboard        from './pages/Admin/Dashboard';
import TaskList              from './pages/Admin/TaskList';

import StripeCancel          from './components/StripeCancel';
import SuccessPage           from './components/SuccessPage';
import StripeSuccess         from './components/StripeSuccess';
import NotFound              from './components/NotFound';

import LexUniverse  from './LexUniverse' 
import BuilderPage  from "./people/BuilderPage";
import GalleryPage from "./pages/gallery";
import NewTeamMember from "./pages/NewTeamMember";
import Lexgate from './Lexgate/Lexgate';
import LexCallAngel   from './Lexcallangel/LexCallAngel';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import Lexwork from './Lexwork/Lexwork';
import OptInPage from "./components/OptInPage";
import Lexburner from "./Lexburner/Lexburner";
import Lexgame from "./Lexgame/Lexgame";
import LexGameMaker from "./Lexgame/LexGameMaker";
import Ontology from "./Ontology/ontology";
import Partner    from "./pages/Partner"; 
import PartnerDetail from "./pages/PartnerDetail"; 
import PartnerApply from "./pages/PartnerApply";
import NewPartner from "./pages/NewPartner";

// Popup helper
const PopupListener = ({ setIsPopupOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.openPopup) {
      setIsPopupOpen(true);
      navigate(location.pathname, { replace: true, state: {} });
    } else if (/^\/p\/[^/]+$/.test(location.pathname)) {
      setIsPopupOpen(true);
    }
  }, [location, setIsPopupOpen, navigate]);

  return null;
};

// Wrapper for shareable prompts
function PromptListWithShare() {
  const { promptId } = useParams();
  return <PromptListPage shareId={promptId} />;
}

function App() {
  const [isSidebarOpen, setIsSidebarOpen]   = useState(true);
  const [isRightSidebarOpen]                = useState(false);
  const [isPopupOpen, setIsPopupOpen]       = useState(false);
  const [gestureEnabled, setGestureEnabled] = useState(() => {
    return localStorage.getItem('gestureEnabled') === 'true';
  });

  useEffect(() => {
    localStorage.setItem('gestureEnabled', gestureEnabled);
  }, [gestureEnabled]);

  const toggleGesture = useCallback(() => {
    setGestureEnabled(e => !e);
  }, []);

  const debugLog = useCallback((msg, data) => console.log(`[DEBUG] ${msg}`, data), []);
  const handleToggleSidebar = useCallback(() => {
    setIsSidebarOpen(prev => !prev);
    debugLog('Sidebar toggled', { isOpen: !isSidebarOpen });
  }, [isSidebarOpen, debugLog]);

  const handleOpenPopup = useCallback(() => {
    setIsPopupOpen(true);
    debugLog('Popup opened');
  }, [debugLog]);

  return (
    <AuthProvider>
      
        <Router>
          {/* Top bar with gesture toggle */}
          <TopMenuBar
            onOpenPopup={handleOpenPopup}
            gestureEnabled={gestureEnabled}
            onToggleGesture={toggleGesture}
          />

          {/* Conditionally mount the hand–mouse overlay */}
          {gestureEnabled && <GestureMouseControl />}

          <PopupListener setIsPopupOpen={setIsPopupOpen} />

          <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', flex: 1 }}>
        

              <div
                style={{
                  flex: 1,
                  padding: '1em',
                  paddingTop: '60px',
                  overflowY: 'auto',
               
                  transition: 'margin 0.3s ease',
                }}
              >
             

                {/* ←—— NOW ONLY <Route> INSIDE ←—— */}
                <Routes>
                  <Route path="/" element={<Navigate to="/home" replace />} />
                  <Route path="/home" element={<HomePage />} />

                  {/* Lex-app dashboard */}
                  <Route path="/lexapp" element={<LexappHomePage />} />
                  {/* Lex-app micro-app loader */}
                  <Route path="/lexapp/:appId" element={<AppsLoader />} />

                  <Route path="/foryou" element={<ForYou />} />
                  <Route path="/lexpartners" element={<Partners />} />

                  <Route path="/signup" element={<SignUp />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />

                  <Route
                    path="/profile/*"
                    element={
                      <PrivateRoute>
                        <UserDashboard />
                      </PrivateRoute>
                    }
                  >
                    <Route index element={<ProfilePanel />} />
                    <Route path="account" element={<ProfilePanel />} />
                    <Route path="security" element={<SecurityPanel />} />
                    <Route path="billing" element={<BillingPanel />} />
                    <Route path="history" element={<HistoryPanel />} />
                    <Route path="assistant" element={<AssistantPanel />} />
                  </Route>

                  <Route path="/our-company" element={<OurCompany />} />

                  <Route path="/success" element={<SuccessPage />} />
                  <Route path="/cancel" element={<StripeCancel />} />
                  <Route path="/subscription/success" element={<StripeSuccess />} />
                  <Route path="/subscription/cancel" element={<StripeCancel />} />

                  <Route path="/lexbuild" element={<LexBuild />} />
                  <Route path="/lexacquire" element={<LexAcquire />} />
                  <Route path="/lexacquire/landscape" element={<Landscape />} />
                  <Route path="/lexacquire/leaderboard" element={<Leaderboard />} />
                  <Route path="/lexacquire/featured" element={<Featured />} />
                  <Route path="/lexacquire/newest" element={<Newest />} />
                  <Route path="/lexacquire/trending" element={<Trending />} />
                  <Route path="/lexacquire/most-viewed" element={<MostViewed />} />
                  <Route path="/lexacquire/most-voted" element={<MostVoted />} />
                  <Route path="/lexacquire/submit" element={<Submit />} />
                  <Route path="/lexacquire/request" element={<Request />} />
                  <Route path="/lexacquire/sponsorship" element={<Sponsorship />} />

                  <Route path="/generative-search" element={<GenerativeSearch />} />

                  <Route path="/lexcode" element={<Lexcode />} />
                  <Route path="/studio" element={<StudioPage />} />

                  <Route path="/prompts/*" element={<LexPromptApp />} />
                  <Route path="/p/:promptId" element={<PromptListWithShare />} />

                  <Route path="/lexnote" element={<LexNoteApp />} />
   <Route path="/people"  element={<BuilderPage />} />
   
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin/signup" element={<AdminSignup />} />
                  <Route path="/admin/dashboard" element={<AdminDashboard />} />
                  <Route path="/admin/tasks" element={<TaskList />} />
                  <Route path="/admin/profile" element={<ProfileSubmission />} />
<Route path="/universe" element={<LexUniverse />} />
<Route path="/gallery" element={<GalleryPage />} />
<Route path="/mail" element={<LexMail />} />   {/* ← add this */}
<Route path="/newteammember" element={<NewTeamMember />} />
 <Route path="/gate" element={<Lexgate />} />
<Route path="/autocall/*" element={<LexCallAngel />} />
<Route path="/privacy" element={<PrivacyPolicy />} />
<Route path="/terms" element={<TermsOfService />} />
  <Route path="/work" element={<Lexwork />} />
  <Route path="/opt-in" element={<OptInPage />} />
<Route path="/call" element={<Lexburner />} />
<Route path="/game" element={<Lexgame />} />
 <Route path="*" element={<NotFound />} />
 <Route path="/more" element={<Ontology />} />
        <Route path="/gamemaker" element={<LexGameMaker />} />
        <Route path="/partners"   element={<Partner />} />  
        <Route path="/partners/:partnerId" element={<PartnerDetail />} />
        <Route path="/partners/apply" element={<PartnerApply />} />
        <Route path="/newpartner" element={<NewPartner />} />
        
                </Routes>
              </div>
            </div>
          </div>
        </Router>
      
    </AuthProvider>
  );
}

export default App;
